import types from './types';
import {
    fetchElementsPaginated,
    fetchElement,
    submitElement
} from './common';
import {
    CALL_API
} from 'redux-api-middleware';


const apiUrl = '/api/seasons';

export function submitSeason(values) {
    return submitElement(apiUrl, values, types.SUBMIT_SEASON);
}
export function fetchSeason(itemId) {
    return fetchElement(apiUrl, itemId, types.ADMIN_LOAD_SEASON);
}

export function fetchSeasons(page = 0, size = 10) {
    return fetchElementsPaginated(`${apiUrl}/paginated`, page, size, types.ADMIN_LOAD_SEASONS);
}

export function fetchAllSeasons() {
    return {
        [CALL_API]: {
            endpoint: apiUrl,
            method: 'GET',
            types: types.LOAD_SEASONS.all
        }
    };
}



// WEBPACK FOOTER //
// ./src/js/actions/seasons.js